import { FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';

import { Card } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';

import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateProduct } from '../Product.hooks';
import { Product } from '../Product.interface';

const ProductDetailCard: React.FC<{
  product: Product;
  onChange?: (product: Product) => void;
}> = ({ product, onChange }) => {
  const { id, name, identifier } = product;
  const formikRef = useRef<FormikValues>();
  const onChangeRef = useRef(onChange);
  const {
    updatedProduct,
    isUpdating,
    updateError,
    updateProduct
  } = useUpdateProduct(id);
  const { isFieldDisabled } = useTaskEntityFields(product.task);
  useEffect(
    () => void (updatedProduct && onChangeRef.current?.(updatedProduct)),
    [updatedProduct]
  );
  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Product Details
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={updateError}
          isSubmitting={isUpdating}
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{ name: name || '', identifier: identifier || '' }}
          onSubmit={(dto: Partial<Product>) => updateProduct(dto)}
        >
          <InlineForm>
            <InlineTextField
              name='name'
              label='Product Name'
              placeholder='Enter product name'
              disabled={isFieldDisabled('name')}
            />
            <InlineTextField
              name='identifier'
              label='Product Identifier'
              placeholder='Enter Product Identifier'
              disabled={isFieldDisabled('identifier')}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default ProductDetailCard;
